"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MachineSecretProviderType = void 0;
var MachineSecretProviderType;
(function (MachineSecretProviderType) {
    MachineSecretProviderType["DefaultProvider"] = "Default Provider";
    MachineSecretProviderType["EntrustRememberedDevicesProvider"] = "Entrust Remembered Devices Provider";
})(MachineSecretProviderType = exports.MachineSecretProviderType || (exports.MachineSecretProviderType = {}));
